import { getCurrencySymbol } from '@angular/common';
import { Directive, Input, ElementRef, OnInit, SimpleChanges, OnChanges } from '@angular/core';

@Directive({
  selector: '[priceWithSpan]'
})
export class PriceWithSpanDirective implements OnChanges {
  @Input() price: number;
  @Input() currency: string;

  constructor(private el: ElementRef) { }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.price && this.price) {
      const [integerPart, decimalPart] = this.price.toFixed(2).split('.');
      let currencyString = '';
      if (this.currency) {
        currencyString = getCurrencySymbol(this.currency, 'wide');
      }

      const formattedValue = `${integerPart}<span>.${decimalPart}${currencyString}</span>`;

      this.el.nativeElement.innerHTML = formattedValue;
    }
  }
}
